import { apiService } from './api';
import { ENDPOINTS } from '../config/api';

// Types matching the admin-api DTOs (MarketControlRequest / MarketControlResultDTO / MarketControlRuleDTO).

export interface MarketControlRequest {
  sportId: number | null;   // internal sport id; null = all sports
  marketType: string | null; // MarketType enum name; null = all market types
  suspendBetting: boolean;
  blockCreation: boolean;
  reason?: string;
}

export interface MarketControlResult {
  affectedEvents: number;
  affectedMarkets: number;
}

export interface MarketControlRule {
  id: number;
  sportId: number | null;
  marketType: string | null;
  suspendBetting: boolean;
  blockCreation: boolean;
  reason?: string;
  updatedAt: string;
}

export const marketControlService = {
  listControls: (): Promise<MarketControlRule[]> => {
    return apiService.get<MarketControlRule[]>(ENDPOINTS.MARKET_CONTROLS);
  },

  applyControl: (request: MarketControlRequest): Promise<MarketControlResult> => {
    return apiService.put<MarketControlResult>(ENDPOINTS.MARKET_CONTROLS, request);
  },

  // Clears the control for a scope by declaring both effects off.
  clearControl: (scope: Pick<MarketControlRule, 'sportId' | 'marketType'>): Promise<MarketControlResult> => {
    return apiService.put<MarketControlResult>(ENDPOINTS.MARKET_CONTROLS, {
      sportId: scope.sportId,
      marketType: scope.marketType,
      suspendBetting: false,
      blockCreation: false,
    });
  },
};
